import React from 'react';
import './App.css';
import './AppMobile.css';
import Bookshelf from './Bookshelf';
import Modal from './components/Modal'

class App extends React.Component {
  constructor(props) {
    super(props);
    this.setShowModal = this.setShowModal.bind(this);
    this.state = {
      route: "",
      books: null, // require("./data/reading_log - vilib.json"),
      showModal: false,
      modalBookData: {},
      mobile: true
    }
  }

  componentDidMount() {
    let b = require('./data/reading_log - vilib.json')
    // console.log(b)
    // console.log('A')
    this.setState({books: b });
    if (window.innerWidth >= 651) {
      this.setState({mobile: false})
    }
  }
  
  async getBookCovers(e, username) {
    // const route = window.location.pathname;
    // console.log(route);
    e.preventDefault()
    let api_call = null;
    // if (route !== "/") {
    api_call = await fetch(`https://vilib-flask-api.herokuapp.com/api${username}`)
                        .then(res => res.json())
                        .then(data => data)
                        .catch(error => console.log(error));
    console.log(api_call)
    api_call = JSON.parse(api_call["img_urls"])
    console.log(api_call)
    // }
    this.setState({route: "", books: api_call });
  }

  setShowModal(val, bookData = {"image_url": "", "title": null}) {
    console.log(bookData)
    this.setState({showModal: val, modalBookData: bookData})
  }
  
  render() {
    return (
      <div className="app">
        {!this.state.books ?
          <div>
            <h1>Vilib</h1>
            <p>Alan's virtual <a href="/" onClick={(e) => this.getBookCovers(e, '/alana')}>library</a></p>
            <p>Carlo's virtual <a href="/" onClick={(e) => this.getBookCovers(e, '/carlosr')}>library</a></p>
            {/* <button onClick={(e) => this.setShowModal(e, true)}>Open Modal</button>
            <Modal showModal={this.state.showModal} bookData={this.state.modalBookData} setShowModal={this.setShowModal}>
              <h3>My modal</h3>
              <p>This is my button-triggered modal</p>
            </Modal> */}
          </div> : (
          this.state.mobile ?
            (<div className="books-wrapper">
              <Bookshelf name="Left Bookshelf" books={this.state.books.slice(0, 11)} setShowModal={this.setShowModal} />
              <Bookshelf name="Center Bookshelf" books={this.state.books.slice(11, 15)} setShowModal={this.setShowModal} />
              <Modal showModal={this.state.showModal} bookData={this.state.modalBookData} setShowModal={this.setShowModal}></Modal>
            </div>) :
            (<div className="books-wrapper">
              <Bookshelf name="Left Bookshelf" books={this.state.books.slice(0, 11)} setShowModal={this.setShowModal} />
              <Bookshelf name="Center Bookshelf" books={this.state.books.slice(11, 40)} setShowModal={this.setShowModal} />
              <Bookshelf name="Right Bookshelf" books={this.state.books.slice(40)} setShowModal={this.setShowModal} />
              <Modal showModal={this.state.showModal} bookData={this.state.modalBookData} setShowModal={this.setShowModal}></Modal>
            </div>)
          )
        }
      </div>
    )
  }
}

export default App;